import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose } from 'class-transformer';

export class CustomCANStatus extends AdditionalInfoImpl {

  @Expose()
  data: any;
}
